/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/date_unit_count.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Counts how many `to_unit` values are contained in a single `from_unit` period for `date`.
 *
 * @example
 * ROW dt = to_datetime("2024-02-15T00:00:00.000Z")
 * | EVAL days = DATE_UNIT_COUNT("day", "month", dt)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'date_unit_count',
  signatures: [
    {
      params: [
        {
          name: 'to_unit',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'from_unit',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'date',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'to_unit',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'from_unit',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'date',
          type: 'date_nanos',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'to_unit',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'from_unit',
          type: 'text',
          optional: false,
        },
        {
          name: 'date',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'to_unit',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'from_unit',
          type: 'text',
          optional: false,
        },
        {
          name: 'date',
          type: 'date_nanos',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'to_unit',
          type: 'text',
          optional: false,
        },
        {
          name: 'from_unit',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'date',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'to_unit',
          type: 'text',
          optional: false,
        },
        {
          name: 'from_unit',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'date',
          type: 'date_nanos',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'to_unit',
          type: 'text',
          optional: false,
        },
        {
          name: 'from_unit',
          type: 'text',
          optional: false,
        },
        {
          name: 'date',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'to_unit',
          type: 'text',
          optional: false,
        },
        {
          name: 'from_unit',
          type: 'text',
          optional: false,
        },
        {
          name: 'date',
          type: 'date_nanos',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
